import axios from "axios";
import config from "../config";

const serverurl = config.apiUrl;
const serverConfig = { withCredentials: true };

export const fetchTodos = async (planId) => {
  const { data } = await axios.get(`${serverurl}/api/v1/yearly-plan/${planId}/todos`, serverConfig);
  return data.todos;
};

export const createTodo = async (planId, todo) => {
  const { data } = await axios.post(`${serverurl}/api/v1/yearly-plan/${planId}/todos`, todo, serverConfig);
  return data.todo;
};

export const createTodoBatch = async (planId, todos) => {
  const { data } = await axios.post(`${serverurl}/api/v1/yearly-plan/${planId}/todos/batch`, { todos }, serverConfig);
  return data.todos;
};

export const updateTodo = async (planId, todoId, fields) => {
  const { data } = await axios.patch(`${serverurl}/api/v1/yearly-plan/${planId}/todos/${todoId}`, fields, serverConfig);
  return data.todo;
};

export const deleteTodo = async (planId, todoId) => {
  await axios.delete(`${serverurl}/api/v1/yearly-plan/${planId}/todos/${todoId}`, serverConfig);
};
